(function () {
  angular.module('imnApp').controller('OltAddController', OltAddController);

  OltAddController.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$filter', 'OltService', 'OltData', 'oltId'];

  function OltAddController($scope, $rootScope, $uibModalInstance, $filter, OltService, OltData, oltId) {
    var vm = this;
    vm.data = OltData;
    vm.requestRunning = false;
    vm.accessTypeList = [
      { label: 'SSH', value: 'SSH', portSugestion: 22 },
      { label: 'Telnet', value: 'TELNET', portSugestion: 23 }
    ];
    // vm.accessTypeList = [{ label: 'Telnet', value: 'TELNET', portSugestion: 23 }];

    var isEdit = !!oltId;

    vm.olt = {
      name: '',
      ip: '',
      // port: 22,
      port: 23,
      mac: '',
      // accessType: { label: 'SSH', value: 'SSH' , portSugestion: 22 },
      accessType: { label: 'Telnet', value: 'TELNET', portSugestion: 23 },
      accessUser: '',
      accessPassword: ''
    };

    vm.modalTitle = isEdit ? 'edit' : 'add';
    vm.labelButton = isEdit ? 'save' : 'add';

    if (isEdit) {
      vm.requestRunning = true;
      OltService.getOlt(oltId).then(successGetOlt).catch(errorGetOlt);
    }

    vm.close = function () {
      if (!vm.requestRunning) {
        $uibModalInstance.dismiss('cancel');
      }
    };
    vm.setPort = function () {
      if (vm.olt.accessType.label == 'Telnet' && (vm.olt.port == null || vm.olt.port == '' || vm.olt.port == 22)) {
        vm.olt.port = vm.olt.accessType.portSugestion;
      } else if (vm.olt.accessType.label == 'SSH' && (vm.olt.port == null || vm.olt.port == '' || vm.olt.port == 23)) {
        vm.olt.port = vm.olt.accessType.portSugestion;
      }
    };
    vm.save = function () {
      if (vm.formAddOlt.$valid && !vm.requestRunning) {
        var data = {
          name: vm.olt.name.toUpperCase(),
          ip: vm.olt.ip,
          port: vm.olt.port,
          accessType: vm.olt.accessType.value,
          accessUser: vm.olt.accessUser,
          accessPassword: vm.olt.accessPassword
        };

        if (vm.olt.mac) {
          data.mac = vm.olt.mac;
        }

        if (isEdit) {
          data.id = vm.olt.id;
        }

        vm.requestRunning = true;
        if (isEdit) {
          OltService.updateOlt(data).then(successUpdate).catch(errorSave);
        } else {
          OltService.addOlt(data).then(successAdd).catch(errorSave);
        }
      }
    };

    function successGetOlt(data) {
      vm.requestRunning = false;
      vm.olt = data;
      vm.olt.accessType = $filter('filter')(vm.accessTypeList, { value: vm.olt.accessType }, true)[0];
    }

    function errorGetOlt(response) {
      vm.requestRunning = false;
      OltService.errorModalConstructor(response, 'get');
      vm.close();
    }

    function successUpdate(data) {
      vm.requestRunning = false;
      OltService.successModalConstructor('save');
      OltData.arrayOlts.forEach(function (olt) {
        if (olt.id == data.id && olt.name != data.name) {
          olt.name = data.name;
        }
      });
      $scope.$emit('oltUpdateSuccess', data);
    }

    function successAdd(data) {
      vm.requestRunning = false;
      OltService.successModalConstructor('save');
      var newOlt = {
        id: data.id,
        name: data.name,
        ip: data.ip,
        port: data.port,
        model: data.model,
        mostCriticalAlarm: 'NONE',
        onLine: true
      };
      OltData.addOltOnList(newOlt);
      $rootScope.$emit('cleanOltFilter', data);
    }

    function errorSave(response) {
      vm.requestRunning = false;
      OltService.errorModalConstructor(response, 'add');
    }
  }
})();
